import { Component, HostBinding, Inject, OnInit } from '@angular/core';

import { CompanyConfigUrlsQuery, LicenseKind, UserLicenseItem, UserLicensesQuery } from '@skylab-shared/business';
import { DataFormats } from '@skylab-shared/constants';
import { L10nBase, RootContextBase } from '@skylab-shared/core';
import { ModuleName } from '@skylab-shared/dataModel';

import { L10n, RootContext } from '@skylab-angular-shared/core';
import { DateFormatPipe } from '@skylab-angular-shared/pipes';
import { IconComponent } from '@skylab-angular-shared/ui';
import { getMinimalOfDates } from '@skylab-shared/utils';

type ExpiringLicenseAnnouncementViewItem = {
    text: string,
    hrefText: string | null,
    url: string | undefined
};

@Component({
    selector: 'skl-expiring-licenses-announcement',
    templateUrl: './expiring-licenses-announcement.component.html',
    styleUrls: ['./expiring-licenses-announcement.component.scss'],
    imports: [IconComponent],
})
export class ExpiringLicensesAnnouncementComponent implements OnInit {
    @HostBinding('class.error') public hasErrorStyle = false;

    public viewAnnouncement: ExpiringLicenseAnnouncementViewItem | null = null;

    public constructor(
        @Inject(RootContext) private readonly rootContext: RootContextBase,
        @Inject(L10n) private readonly l10n: L10nBase,
        private readonly dateFormatPipe: DateFormatPipe
    ) { }

    public ngOnInit(): void {
        this.handleAsync();
    }

    private async handleAsync(): Promise<void> {
        const licenses = this.rootContext.getPreloaded(UserLicensesQuery);
        if (licenses.kind === LicenseKind.UdostepnionaPrzezBiuroRachunkowe) return;

        const withExpiration = licenses.modules.filter(e => e.active && (e.expirationKind !== 'None'));
        this.hasErrorStyle = withExpiration.some(e => e.expirationKind === 'Error');
        this.viewAnnouncement = withExpiration.length ? await this.prepareViewItemAsync(withExpiration) : null;
    }

    private async prepareViewItemAsync(modules: UserLicenseItem[]): Promise<ExpiringLicenseAnnouncementViewItem> {
        const urls = await this.rootContext.getAsync(CompanyConfigUrlsQuery);

        return {
            text: this.getExpiringLicenseAnnouncementContent(modules),
            hrefText: urls?.license ? this.l10n._T('scenes.announcements.license.prolong-link') : null,
            url: urls?.license,
        };
    }

    private getExpiringLicenseAnnouncementContent(modules: UserLicenseItem[]): string {
        const modulesLables: Record<ModuleName, string> = {
            [ModuleName.PakietPodstawowy]: this.l10n._T('scenes.announcements.license.basic-package'),
            [ModuleName.Fiskalizacja]: this.l10n._T('scenes.announcements.license.fiscalization'),
            [ModuleName.UzytkownikPlus]: this.l10n._T('scenes.announcements.license.user-plus'),
            [ModuleName.Magazyn]: this.l10n._T('scenes.announcements.license.inventory')
        };

        const module = modules.map(elem => modulesLables[elem.name]).filter(Boolean).join(', ');
        const minimalDate = getMinimalOfDates(...modules.map(e => e.expirationDate));
        const date = minimalDate ? this.dateFormatPipe.transform(minimalDate, DataFormats.date.dayMonthYear) : '';

        return this.l10n._T('scenes.announcements.license.expires', {module, date});
    }
}
